export enum Broker {
  Axo,
  Zmarta,
}
